var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotaltickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5721 16.6905C7.32804 16.6905 7.12976 16.9163 7.12976 17.1953C7.12976 17.4743 7.32808 17.7005 7.5721 17.7005C7.81648 17.7005 8.01449 17.4743 8.01449 17.1953C8.01449 16.9163 7.81648 16.6905 7.5721 16.6905Z",
    fill: "#5DA3E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5721 14.8029C7.32804 14.8029 7.12976 15.0291 7.12976 15.3081C7.12976 15.5868 7.32808 15.8129 7.5721 15.8129C7.81648 15.8129 8.01449 15.5868 8.01449 15.3081C8.01449 15.029 7.81648 14.8029 7.5721 14.8029Z",
    fill: "#5DA3E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1963 8.72919H8.01444H7.93338H7.12967H4.01616H3.21252V9.64658V19.0822V20H4.0162H7.12971H7.93342H8.01448H19.1963H20V19.0822V9.64658V8.72919H19.1963ZM19.1963 19.0822H8.01444C8.01444 18.8032 7.81643 18.5774 7.57206 18.5774C7.32799 18.5774 7.12971 18.8032 7.12971 19.0822H4.0162V9.64658H7.12971C7.12971 9.92559 7.32803 10.1514 7.57206 10.1514C7.81643 10.1514 8.01444 9.92563 8.01444 9.64658H19.1962L19.1963 19.0822Z",
    fill: "#5DA3E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5721 12.916C7.32804 12.916 7.12976 13.1421 7.12976 13.4211C7.12976 13.6998 7.32808 13.9259 7.5721 13.9259C7.81648 13.9259 8.01449 13.6998 8.01449 13.4211C8.01449 13.1421 7.81648 12.916 7.5721 12.916Z",
    fill: "#5DA3E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5721 11.0289C7.32804 11.0289 7.12976 11.2547 7.12976 11.5337C7.12976 11.8128 7.32808 12.0389 7.5721 12.0389C7.81648 12.0389 8.01449 11.8128 8.01449 11.5337C8.01449 11.2547 7.81648 11.0289 7.5721 11.0289Z",
    fill: "#5DA3E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60336 7.33372L14.432 1.24408L17.553 7.8114H18.467L15.1381 0.806017L14.7551 0L14.0484 0.437087L4.22063 6.52739L4.14938 6.57133L3.44297 7.00873L0.706406 8.70471L0 9.14242L0.38332 9.94911L2.4091 14.2119V12.2878L1.08977 9.5114L2.4091 8.69347L4.60336 7.33372Z",
    fill: "#5DA3E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotaltickets);
export default __webpack_public_path__ + "static/media/total tickets.6bd1e802bacf3a45cfb3370960d455a1.svg";
export { ForwardRef as ReactComponent };